import React from "react";

const ExclusiveBadge: React.FC<React.ComponentProps<"svg">> = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={props.opacity ?? 1}>
      <path
        d="M1.16487 5.83548C0 8.12166 0 11.1144 0 17.1V30.9C0 36.8856 0 39.8783 1.16487 42.1645C2.18951 44.1755 3.82449 45.8105 5.83548 46.8351C7.73947 47.8053 10.1336 47.9674 14.3384 47.9946L17.2579 37.0989C14.5895 35.5412 10.3407 32.0595 7.84425 24.8803C4.00349 13.8352 8.89501 9.64524 9.98218 8.95136C11.0693 8.25749 14.7541 6.12508 19.4645 9.0292C22.8475 11.1146 24.2084 15.0711 24.707 17.1364C24.833 17.657 25.4858 17.8319 25.8544 17.4439C27.3189 15.9045 30.4757 13.1586 34.4481 13.044C39.9803 12.8844 42.1052 16.5735 42.6997 17.718C43.2943 18.8625 45.4356 24.9368 36.5868 32.5818C30.8653 37.525 25.4715 38.4324 22.3738 38.4563L19.8165 48H30.9C36.8856 48 39.8783 48 42.1645 46.8351C44.1755 45.8105 45.8105 44.1755 46.8351 42.1645C48 39.8783 48 36.8856 48 30.9V17.1C48 11.1144 48 8.12166 46.8351 5.83548C45.8105 3.82449 44.1755 2.18951 42.1645 1.16487C39.8783 0 36.8856 0 30.9 0H17.1C11.1144 0 8.12166 0 5.83548 1.16487C3.82449 2.18951 2.18951 3.82449 1.16487 5.83548Z"
        fill="currentColor"
      />
      <path
        d="M27.8673 27.0098C27.8068 26.6276 27.4238 26.2446 26.6578 25.4787L23.5792 22.4C22.8132 21.6341 22.4303 21.2511 22.048 21.1906C21.7146 21.1378 21.3745 21.2289 21.1121 21.4413C20.8114 21.6849 20.6712 22.2081 20.3908 23.2544L19.264 27.4598C18.9836 28.5062 18.8434 29.0293 18.9821 29.3906C19.1031 29.7058 19.3521 29.9548 19.6672 30.0757C20.0286 30.2144 20.5517 30.0743 21.598 29.7939L25.8035 28.667C26.8498 28.3867 27.373 28.2465 27.6165 27.9458C27.829 27.6834 27.9201 27.3433 27.8673 27.0098Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default ExclusiveBadge;
